document.querySelectorAll(".js-readmore").forEach((textEl) => {
    const fullText = textEl.textContent.replace(/\s+/g, " ").trim();
    const limit = 300;
    const btn = textEl.nextElementSibling;

    if (btn && fullText.length > limit) {
        btn.classList.remove("hidden");
        const shortText = fullText.substring(0, limit) + "…";
        textEl.textContent = shortText;
        btn.style.display = "inline-block";

        let expanded = false;
        btn.addEventListener("click", () => {
            if (!expanded) {
                textEl.textContent = fullText;
                btn.textContent = "閉じる";
                expanded = true;
            } else {
                textEl.textContent = shortText;
                btn.textContent = "もっと見る";
                expanded = false;
            }
        });
    }
});

const boxSearch = document.getElementById("jsSearchBox");
const searchConditions = document.getElementById("searchConditions");
const searchFooter = document.getElementById('searchFooter');
let isAppend = false;

window.addEventListener('scroll', () => {
    if (!searchFooter || !boxSearch) return;
    const hasBoxSearch = searchFooter.querySelector("#jsSearchBox");
    const targetPoint = document.documentElement.scrollHeight - window.innerHeight - boxSearch?.offsetHeight - document.getElementById('header').offsetHeight;
    if (isAppend) return;
    if(window.pageYOffset > targetPoint) {
        if (!hasBoxSearch) {
            boxSearch.remove();
            searchFooter.appendChild(boxSearch);
            searchConditions.style.height = "0";
            isAppend = true;
        }
    }
});

document.addEventListener("click", function (e) {
    if (e.target.closest(".jsRemoveResult")) {
        e.preventDefault();
        const tr = e.target.closest("tr");
        if (tr) {
            tr.remove();
        }
    } else if (e.target.closest(".jsChangeOtpSearch")) {
        e.preventDefault();
        isAppend = false;
        boxSearch.remove();
        searchConditions.appendChild(boxSearch);
        const fullHeight = boxSearch.scrollHeight + "px";
        if (searchConditions.offsetHeight === 0) {
            searchConditions.style.height = fullHeight;
        } else {
            searchConditions.style.height = fullHeight;
            requestAnimationFrame(() => {
                searchConditions.style.height = "0";
            });
            boxSearch.remove();
            searchFooter.appendChild(boxSearch);
            isAppend = true;
        }
    }
});

window.addEventListener("resize", () => {
    if (window.innerWidth <= 768) return;
    if (!searchConditions) return;
    if (searchConditions.offsetHeight > 0) {
        searchConditions.style.height = "auto";
        const newHeight = searchConditions.scrollHeight;
        searchConditions.style.height = newHeight + "px";
    }
});

document.querySelectorAll('.jsButtonContactSearch').forEach(link => {
    link.addEventListener('click', () => {
        sessionStorage.setItem('reloadSearch', '1');
    });
});
window.addEventListener('pageshow', () => {
    if (sessionStorage.getItem('reloadSearch') && window.location.href.includes('/search')) {
        sessionStorage.removeItem('reloadSearch');
        location.reload();
    }
});